import { AutospinButton }           from '../button/button.autospin.class'
import { BetButton }                from '../button/button.bet.class'
import { Button }                   from '../button/button.class'
import { BUTTON_CONFIG }            from '../../constants/button/button-config.constant'
import { ORIENTATION }              from '../../constants/orientation/orientation.constant'
import { ORIENTATIONS }             from '../../constants/orientation/orientations.constant'
import { BUTTON_PSEUDO_STATES }     from '../../constants/button/button-pseudo-states.constant'
import { BUTTON_SIZE }              from '../../constants/button/button-size.constant'
import { GuaranteedDebounce }       from '../debounce/guaranteed-debounce/debounce.guaranteed-debounce.class'
import { Settings }                 from '../settings/settings.class'
import { UIManager }                from '../uiManager/uiManager.class'
import { MenuManager }              from '../menuManager/menuManager.class'
import { NEW_SETTINGS }             from '../../constants/newSettings/new-settings.constant'
import { FooterManager }            from '../footerManager/footerManager.class'
import { SpinButton }               from '../button/button.spin.class'
import { SPIN_STATE }               from '../../constants/spinState/spin-state.constant'
import { AUTOSPIN_STATE }           from '../../constants/spinState/autospin-state.constant'
import { ConsoleManager }           from '../consoleManager/consoleManager.class'
import { GameHistoryManager }       from '../gameHistoryManager/gameHistoryManager.class'
import { PaytableManager }          from '../paytableManager/paytableManager.class'
import { Action }                   from '../action/action.class'
import { FontLoader }               from '../fontLoader/fontLoader.class'
import { localStorageSupported }    from '../../functions/localStorage-supported.function'
import { AutoInput }                from '../autoInput/autoInput.class'
import { getZIndex }                from '../../functions/get-zindex.function'

//Autospin button data URI's
import * as autospinStart from '../../assets/mobile/mb-pt-autsopin-start.svg'
import * as autospinSpin  from '../../assets/mobile/mb-pt-autsopin-spin.svg'
import * as autospinStop  from '../../assets/mobile/mb-pt-autsopin-stop.svg'

//Bet button data URI
import * as bet from '../../assets/mobile/mb-pt-btn-bet.svg'

//Close button data URI
import * as close from '../../assets/mobile/mb-pt-btn-close.svg'

//Menu button data URI
import * as menu from '../../assets/mobile/mb-pt-btn-menu.svg'

//Paytable button data URI
import * as paytable from '../../assets/mobile/mb-pt-btn-paytable.svg'

//Sound button data URI's
import * as soundOff from '../../assets/mobile/mb-pt-btn-sound-off.svg'
import * as soundOn  from '../../assets/mobile/mb-pt-btn-sound-on.svg'

//Spin button data URI's
import * as spin from '../../assets/mobile/mb-pt-btn-spin.svg'
import * as stop from '../../assets/mobile/mb-pt-btn-stop.svg'

//Desktop data uri's
import * as autospinStartDownDt from '../../assets/desktop/buttons/dt-autospin-btn-down.png'
import * as autospinStartOverDt from '../../assets/desktop/buttons/dt-autospin-btn-over.png'
import * as autospinStartUpDt   from '../../assets/desktop/buttons/dt-autospin-btn-up.png'
import * as autospinPlayDownDt  from '../../assets/desktop/buttons/dt-autospin-play-down.png'
import * as autospinPlayOverDt  from '../../assets/desktop/buttons/dt-autospin-play-over.png'
import * as autospinPlayUpDt    from '../../assets/desktop/buttons/dt-autospin-play-up.png'
import * as autospinStopDownDt  from '../../assets/desktop/buttons/dt-autospin-stop-down.png'
import * as autospinStopOverDt  from '../../assets/desktop/buttons/dt-autospin-stop-over.png'
import * as autospinStopUpDt    from '../../assets/desktop/buttons/dt-autospin-stop-up.png'

import * as betDownDt from '../../assets/desktop/buttons/dt-bet-btn-down.png'
import * as betOverDt from '../../assets/desktop/buttons/dt-bet-btn-over.png'
import * as betUpDt   from '../../assets/desktop/buttons/dt-bet-btn-up.png'

import * as menuDownDt  from '../../assets/desktop/buttons/dt-menu-btn-down.png'
import * as menuOverDt  from '../../assets/desktop/buttons/dt-menu-btn-over.png'
import * as menuUpDt    from '../../assets/desktop/buttons/dt-menu-btn-up.png'
import * as closeDownDt from '../../assets/desktop/buttons/dt-close-btn-down.png'
import * as closeOverDt from '../../assets/desktop/buttons/dt-close-btn-over.png'
import * as closeUpDt   from '../../assets/desktop/buttons/dt-close-btn-up.png'

import * as paytableDownDt from '../../assets/desktop/buttons/dt-paytable-down.png'
import * as paytableOverDt from '../../assets/desktop/buttons/dt-paytable-over.png'
import * as paytableUpDt   from '../../assets/desktop/buttons/dt-paytable-up.png'

import * as soundOffDownDt from '../../assets/desktop/buttons/dt-sound-off-down.png'
import * as soundOffOverDt from '../../assets/desktop/buttons/dt-sound-off-over.png'
import * as soundOffUpDt   from '../../assets/desktop/buttons/dt-sound-off-up.png'
import * as soundOnDownDt  from '../../assets/desktop/buttons/dt-sound-on-down.png'
import * as soundOnOverDt  from '../../assets/desktop/buttons/dt-sound-on-over.png'
import * as soundOnUpDt    from '../../assets/desktop/buttons/dt-sound-on-up.png'

import * as spinDownDt     from '../../assets/desktop/buttons/dt-spin-btn-down.png'
import * as spinOverDt     from '../../assets/desktop/buttons/dt-spin-btn-over.png'
import * as spinUpDt       from '../../assets/desktop/buttons/dt-spin-btn-up.png'
import * as stopDownDt     from '../../assets/desktop/buttons/dt-spin-stop-btn-down.png'
import * as stopOverDt     from '../../assets/desktop/buttons/dt-spin-stop-btn-over.png'
import * as stopUpDt       from '../../assets/desktop/buttons/dt-spin-stop-btn-up.png'

/**
 * @file Defines the {@link ButtonManager} class
 * @author Joe Thompson <joe.thompson@1x2network.com>
 * @version 1.0.30
 */

/** Class for handling the initialisation of buttons */
export class ButtonManager {

    /**
     * Object for storing all button assets
     * @memberof ButtonManager
     * @protected
     * @instance
     * @type {button-assets}
     */
    _assets
    
    /**
     * Array storing all buttons
     * @memberof ButtonManager
     * @protected
     * @instance
     * @type {Button[]}
     */
    _buttons

    /**
     * Reference to console manager
     * @memberof ConsoleManager
     * @protected
     * @instance
     * @type {ConsoleManager}
     */
    _consoleManager

    /**
     * Reference to footer manager
     * @memberof ButtonManager
     * @protected
     * @instance
     * @type {FooterManager}
     */
    _footerManager
    
    /**
     * Array storing all image data uri's
     * @memberof ButtonManager
     * @protected
     * @instance
     * @type {string[]}
     */
    _imgs

    /**
     * Orientation of device
     * @memberof ButtonManager
     * @protected
     * @instance
     * @type {string}
     */
    _orientation

    /**
     * Reference to paytable manager
     * @memberof ButtonManager
     * @protected
     * @instance
     * @type {PaytableManager}
     */
    _paytableManager

    /**
     * Preview event handler
     * @memberof ButtonManager
     * @protected
     * @instance
     * @type {Action}
     */
    _onPreview

    /**
     * Reference to UI settings
     * @memberof ButtonManager
     * @protected
     * @instance
     * @type {Settings}
     */
    _settings

    /**
     * Reference to UI manager
     * @memberof ButtonManager
     * @protected
     * @instance
     * @type {UIManager}
     */
    _uiManager

    /**
     * Promise for when help file loaded
     * @memberof ButtonManager
     * @protected
     * @instance
     * @type {Promise<undefined>}
     */
    _helpLoaded

    /**
     * Resolve function for help Loaded Promise
     * @memberof ButtonManager
     * @protected
     * @instance
     * @type {Function}
     */
    _helpResolved

    /**
     * Whether own session bar solution is being used
     * @memberof ButtonManager
     * @protected
     * @instance
     * @type {boolean}
     */
    _sessionBar

    /** 
     * Initialise needed buttons.
     * @param {object} click_ - Object containing click event handlers where needed.
     */
    constructor(click_) {

        this.preload()  //Preload fonts

        this._imgs = [] //Create empty array to store image data uri's
    
        let resolve                                                         //Resolve function for loaded Promise
        this._helpLoaded    = new Promise(r_ => this._helpResolved = r_)    //Initialise helpLoaded Promise
        let loaded          = new Promise(r_ => resolve = r_)               //Initialise Promise for buttonManager exposed to window

        //If mobile
        if (framework.isTouch()) {

            //Store autospin button data URI's
            this._imgs.push(autospinStart)
            this._imgs.push(autospinSpin)
            this._imgs.push(autospinStop)

            //Store bet button data URI
            this._imgs.push(bet)

            //Store menu button data URI's
            this._imgs.push(close)
            this._imgs.push(menu)

            //Store paytable button data URI's
            this._imgs.push(close)
            this._imgs.push(paytable)

            //Store sound button data URI's
            this._imgs.push(soundOff)
            this._imgs.push(soundOn)

            //Store spin button data URI's
            this._imgs.push(spin)
            this._imgs.push(stop)

            this._orientation = ORIENTATION //Create new orientation handler class
            this._orientation.check()       //Check orientation

        }

        //Desktop
        else {

            //Store autospin button data uri's
            this._imgs.push(autospinStartDownDt)
            this._imgs.push(autospinStartOverDt)
            this._imgs.push(autospinStartUpDt)
            this._imgs.push(autospinPlayDownDt)
            this._imgs.push(autospinPlayOverDt)
            this._imgs.push(autospinPlayUpDt)
            this._imgs.push(autospinStopDownDt)
            this._imgs.push(autospinStopOverDt)
            this._imgs.push(autospinStopUpDt)

            //Store bet button data uri's
            this._imgs.push(betDownDt)
            this._imgs.push(betOverDt)
            this._imgs.push(betUpDt)

            //Store menu button data uri's
            this._imgs.push(closeDownDt)
            this._imgs.push(closeOverDt)
            this._imgs.push(closeUpDt)
            this._imgs.push(menuDownDt)
            this._imgs.push(menuOverDt)
            this._imgs.push(menuUpDt)
            
            //Store paytable button data uri's
            this._imgs.push(closeDownDt)
            this._imgs.push(closeOverDt)
            this._imgs.push(closeUpDt)
            this._imgs.push(paytableDownDt)
            this._imgs.push(paytableOverDt)
            this._imgs.push(paytableUpDt)
            
            //Store sound button data uri's
            this._imgs.push(soundOffDownDt)
            this._imgs.push(soundOffOverDt)
            this._imgs.push(soundOffUpDt)
            this._imgs.push(soundOnDownDt)
            this._imgs.push(soundOnOverDt)
            this._imgs.push(soundOnUpDt)

            //Store spin button data uri's
            this._imgs.push(spinDownDt)
            this._imgs.push(spinOverDt)
            this._imgs.push(spinUpDt)
            this._imgs.push(stopDownDt)
            this._imgs.push(stopOverDt)
            this._imgs.push(stopUpDt)

        }
        
        this._assets = Object.create(null)                  //Initialize empty object for data structure storing button assets
        let buttons  = Object.keys(BUTTON_CONFIG.console)   //Retrieve buttons
        let states   = Object.values(BUTTON_CONFIG.console) //Retrieve button states

        let count = 0 //Iterator for accessing images

        this._uiManager = new UIManager() //Initialize UI Manager

        //Loop through every button
        for (let i = 0; i < buttons.length; i++) {

            let button           = buttons[i]          //Store current button
            this._assets[button] = Object.create(null) //Create empty object for storing button states for button

            //Loop through buttons possible states
            for (let j = 0; j < states[i].states.length; j++) {

                let state                   = states[i].states[j] //Store current state
                this._assets[button][state] = Object.create(null) //Create empty object for storing pseudo states for that state

                //Loop through button pseudo states
                for (let k = 0; k < BUTTON_PSEUDO_STATES.length; k++) {
                    
                    let btnState = BUTTON_PSEUDO_STATES[k] //Store current pseudo state
                    
                    //If mobile
                    if (framework.isTouch()) {

                        //Add up pseudo state
                        if(btnState === 'up') {
                            
                            this._assets[button][state][btnState] = this._imgs[count] //Store image asset
                            count++                                                   //Increment image iterator

                        }

                    }

                    //Desktop
                    else {

                        //Add up, over & down states
                        if (btnState === 'up' || btnState === 'over' || btnState === 'down') {

                            //Store image asset
                            this._assets[button][state][btnState] = this._imgs[count]

                            //Increment image iterator
                            count++

                        }

                    }

                }

            }

        }

        this._buttons = [] //Initialise buttons array

        //Loop through all buttons to be made
        for (let i = 0; i < buttons.length; i++) {
            
            let buttonName = buttons[i]               //Store button name
            let assets     = this._assets[buttonName] //Retrieve assets for that button

            //If bet button
            if (buttonName === 'bet') {

                //If mobile
                if (framework.isTouch()) {
                    this._buttons.push(new BetButton(assets, buttonName, states[i].states, true, true)) //Create button with text field
                }

                //Desktop
                else {
                    this._buttons.push(new BetButton(assets, buttonName, states[i].states, true, true, click_[buttonName])) //Create desktop bet button
                }

            }

            //If autospin button
            else if (buttonName === 'autospin') {

                //If mobile
                if (framework.isTouch()) {
                    this._buttons.push(new AutospinButton(assets, buttonName, states[i].states, true, true, click_[buttonName])) //Create button with text field
                }

                //Desktop
                else {
                    this._buttons.push(new AutospinButton(assets, buttonName, states[i].states, true, true, click_[buttonName])) //Create desktop autospin button
                }

            }

            //If spin button
            else if (buttonName === 'spin') {

                //If mobile
                if (framework.isTouch()) {
                    this._buttons.push(new Button(assets, buttonName, states[i].states, true, false, click_[buttonName])) //Create spin button
                }

                //Desktop
                else {
                    this._buttons.push(new SpinButton(assets, buttonName, states[i].states, true, false, click_[buttonName])) //Create desktop spin button
                }

            }

            //If paytable button
            else if (buttonName === 'paytable' || buttonName === 'menu') {

                //Paytable click function
                let func = () => {

                    click_[buttonName] && click_[buttonName]()  //Execute original click function passed into button

                    //If Session bar in use
                    if (this._sessionBar) {

                        let sessionBar = Array.from(document.querySelectorAll('.gf-session-bar'))[0]                            //Store session bar node
                        document.getElementById('mainViewport').style.zIndex = window.getComputedStyle(sessionBar).zIndex - 1   //Display session bar on top of menu

                    }

                }

                this._buttons.push(new Button(assets, buttonName, states[i].states, true, false, func)) //Initialise paytable button

            }

            //Any other button
            else {
                this._buttons.push(new Button(assets, buttonName, states[i].states, true, false, click_[buttonName]))
            }

        }

        //If mobile
        if (framework.isTouch()) {
            //TODO: for DT handle settings class for inverted controls
            this._settings           = new Settings()           //Initialize UI settings
            this._footerManager      = new FooterManager()      //Initialize footer manager
            this._menuManager        = new MenuManager(this._helpLoaded)        //Initialize menu manager
            this._gameHistoryManager = new GameHistoryManager() //Initialize game history manager
            this._paytableManager    = new PaytableManager(loaded)    //Initialize paytable manager

            //Check orientation
            this._orientation.check()

            //Initially set orientation styling for arch
            this._uiManager.arch(this._orientation.orientation)

            //Once new UI settings have been initialised
            this.settings.promise.then(() => {

                //Initially apply UI styling depending on UI is inverted or not
                this._uiManager.invert(this.settings.inverted(), this._buttons)
                
                //When user toggles inverting controls setting, update UI
                NEW_SETTINGS.controls.onChange.add(v_ => this._uiManager.invert(v_, this._buttons))

            })

            this._onPreview = new Action()              //Initialize preview custom event
            this._onPreview.add(v_ => this.preview(v_)) //Add custom event when user is viewing/closing preview

            //Determine event to fire for detecting device orientation
            let type = this.iframe ? 'resize' : 'orientationchange'

            //Add event listener on orientation change
            window.addEventListener(type, () => {
                new GuaranteedDebounce(() => this.set(this._orientation.check()), 500).fire() //Set orientation
            })

        }

        //Desktop
        else {

            this._consoleManager     = new ConsoleManager()                 //Initialize console manager
            this._footerManager      = new FooterManager()                  //Initialize footer manager
            this._paytableManager    = new PaytableManager(loaded)          //Initialize paytable manager
            this._menuManager        = new MenuManager(this._helpLoaded)    //Initialize menu manager
            this._gameHistoryManager = new GameHistoryManager()             //Initialize game history manager
            new AutoInput()                                                 //Initialise autoInput functionality

            //Expose to window
            window['AUTOSPIN_STATE'] = AUTOSPIN_STATE
            window['SPIN_STATE']     = SPIN_STATE

            //If Session bar in use
            if (window.f1x2.SESSION_BAR && window.f1x2.SESSION_BAR.use) {

                //Once UI loaded
                loaded.then(r_ => {

                    let { f1x2 }            = window    //Destructure window
                    let { SessionBarInit }  = f1x2      //Destructure f1x2
        
                    //Once Session bar initialised display UI on top of session bar
                    SessionBarInit.ready.then(() => document.getElementById('mainViewport').style.zIndex = getZIndex('.gf-session-bar') + 1)

                })

            }

        }

        //Once UI loaded
        loaded.then(r_ => {

            let { f1x2 }            = window    //Destructure window
            let { SessionBarInit }  = f1x2      //Destructure f1x2

            //When session bar ready Promise resolved
            SessionBarInit.ready.then(() => {

                this._sessionBar = SessionBarInit.use   //Update sessionBar flag if using our own session bar

                //If session bar in use
                if (this._sessionBar) {
                    document.body.dataset.sessionBar = 'true'    //Update data attribute
                }

            })

        })

        //Initialise fixed button states
        this.bet().state      = 'BET'
        this.menu().state     = 'MENU'
        this.paytable().state = 'PAYTABLE'

        //If localStorage supported
        if (localStorageSupported()) {
            localStorage.getItem('slots__sound') === 'true' ? this.sound().state = 'ON' : this.sound().state = 'OFF'    //Set sound button state
        }

        //Use localStorage fallback
        else {
            localStorageFallback_['slots__sound'] === 'true' ? this.sound().state = 'ON' : this.sound().state = 'OFF'   //Set sound button state
        }

        window.newUI = this //Bind instance to window
        resolve()           //Resolve loaded Promise

    }

    /** Get autospin button */ autospin() { return this._buttons[0] }
    /** Get bet button */      bet()      { return this._buttons[1] }
    /** Get menu button */     menu()     { return this._buttons[2] }
    /** Get paytable button */ paytable() { return this._buttons[3] }
    /** Get sound button */    sound()    { return this._buttons[4] }
    /** Get spin button */     spin()     { return this._buttons[5] }

    /** Get assets */               get assets()             { return this._assets }
    /** Get buttons */              get buttons()            { return this._buttons }
    /** Get footer manager */       get footerManager()      { return this._footerManager }
    /** Get game history manager */ get gameHistoryManager() { return this._gameHistoryManager }
    /** Get orientation */          get orientation()        { return this._orientation }
    /** Get paytable manager */     get paytableManager()    { return this._paytableManager }
    /** Get onPreview */            get onPreview()          { return this._onPreview }
    /** Get settings */             get settings()           { return this._settings }
    /** Get UI Manager */           get uiManager()          { return this._uiManager }
    /** Get helpResolved */         get helpResolved()       { return this._helpResolved }
    /** Get menuManager */          get menuManager()        { return this._menuManager }

    /** 
     * Sets button orientation
     * @param {string} v_ - New orientation
     */
    set(v_) {

        let o = ORIENTATIONS.filter(o_ => o_ !== v_) //Retrieve old orientation
        
        //Loop through buttons
        for (let i = 0; i < this._buttons.length; i++) {

            let button = this._buttons[i] //Store button

            //If button has text
            if (button.text) {
                
                button.elem.children[0].classList.remove(o[0]) //Remove old orientation styling
                button.elem.children[0].classList.add(v_)      //Add new orientation styling

            }
            
            button.orientation = v_ //Set new orientation

            button.elem.classList.remove(o[0]) //Remove old orientation styling
            button.elem.classList.add(v_)      //Add new orientation styling

            button.backgroundImage() //Update button background image

            //If mobile
            if (framework.isTouch()) {

                button.elem.classList.remove(BUTTON_SIZE.mobile[o[0]][button.id].size) //Remove old orientation button size styling
                button.elem.classList.add(BUTTON_SIZE.mobile[v_][button.id].size)      //Add new orientation button size styling

            }

            //Desktop
            else {

                button.elem.classList.remove(BUTTON_SIZE.desktop[button.id].size) //Remove old orientation button size styling
                button.elem.classList.add(BUTTON_SIZE.desktop[button.id].size)    //Add new orientation button size styling

            }

        }

        this._uiManager.arch(this._orientation.orientation) //Manages button arch styling

    }

    /**
     * Handle rendering UI depending whether user is still viewing preview
     * @param {boolean} v_ - Whether user is still viewing preview
     */
    preview(p_) {

        let newConsole = document.getElementById('new_betConsoleMobile') //Retrieve new console node

        //Hide/show new console depending if user has closed preview screen or not
        p_ ? newConsole.classList.add('hidden') : newConsole.classList.remove('hidden')

    }

    /**
     * Whether game launched in an iframe
     * NB: https://stackoverflow.com/a/326076/2030247
     * @return {boolean} Whether game launched in iframe or not 
     */
    iframe() {
        try {
            return window.self !== window.top
        }
        catch (e) {
            return true
        }
    }

    /** Preload fonts */
    preload() {

        let fonts   = [{ name: 'Montserrat', weight: '700' }]   //Fonts to preload
        let toLoad  = fonts.length                              //Fonts to load
        let loaded  = 0                                         //Fonts loaded

        return new Promise((resolve_, reject_) => {

            //Loop through fonts
            fonts.map(v_ => {

                let loader  = new FontLoader(v_)    //Create new FontLoader

                //Load fonts
                loader.load(v_).then(() => {

                    loaded++    //Increment loaded

                    //If all fonts loaded
                    if (loaded === toLoad) {
                        resolve_()  //Resolve Promise
                    }

                })
    
            })

        })

    }

}